/**
 * 방화벽 Batch File
 * Ipv4, Ipv6
 *
 * @since 2020-07-06
 * @author mk.ko
 */

import {
  CmApiPrefix as cmApiPrefix
} from 'utils'
import {pcDownloadFile} from '~/utils/files'

// 방화벽 정책 - 배치 입력 데이터
const initFwBatchData = () => {
  return {
    fw_rule_seq: void 0,
    fw_grp_id: 1
  }
}

export const state = () => ({
  fwBatchData: initFwBatchData(),
  uploadStatus: void 0
})

export const mutations = {
  initFwBatchState (state) {
    state.fwBatchData = initFwBatchData()
    state.uploadStatus = void 0
  },

  // 파일 업로드
  updateUploadStatus (state, payload) {
    state.uploadStatus = payload
  }
}

export const actions = {

  // 엑셀 파일 다운로드
  async fileDownload ({state}, {version, deviceId}) {
    const ipVersionType = Number(version) === 4 ? 1 : 2
    const {data, fileName} = await this.$axios.$file(`${cmApiPrefix}/fw-rule/batch/save/${deviceId}/${ipVersionType}`, {
      responseType: 'blob',
      method: 'get'
    })
    pcDownloadFile(data, fileName)
  },

  // 파일 업로드
  async fileUpload ({commit, state}, {file, version}) {
    const seq = typeof state.fwBatchData.fw_rule_seq === 'undefined' ? 0 : Number(state.fwBatchData.fw_rule_seq)

    const formData = new FormData()
    formData.append('fw_rule_ip_ver_type', Number(version) === 4 ? 1 : 2)
    formData.append('fw_batch_file_name', file)

    const res = await this.$axios.$put(`${cmApiPrefix}/fw-rule/batch/${state.fwBatchData.fw_grp_id}/${seq}`,
      formData,
      {
        successAlert: false
      })

    if (res.code === 'ok') {
      commit('updateUploadStatus', res.result)
    } else {
      commit('updateUploadStatus', void 0)
    }
    return res
  }

}

export const getters = {}

export const strict = false
